import { render, staticRenderFns } from "./_base-select-field.vue?vue&type=template&id=6dc578f4&scoped=true"
import script from "./_base-select-field.vue?vue&type=script&lang=js"
export * from "./_base-select-field.vue?vue&type=script&lang=js"
import style0 from "./_base-select-field.vue?vue&type=style&index=0&id=6dc578f4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc578f4",
  null
  
)

export default component.exports